import { createLocalVue, shallowMount } from '@vue/test-utils';
import Vuex from 'vuex';
import { getObjProperty } from '../../../utilities/mrVueUtils';

/**** TEST MODULE ****/
import CartMembershipProgram from './CartMembershipProgram';

/**** MOUNTING OPTIONS ****/
function createWrapper() {
  const store = new Vuex.Store({
    modules: store_modules,
  });

  return shallowMount(CartMembershipProgram, {
    localVue,
    methods,
    mocks,
    provide,
    stubs,
    store,
  });
}

const localVue = createLocalVue();
localVue.use(Vuex);

localVue.filter('currency', jest.fn());

const methods = {
  trackEvent: jest.fn()
};
const mocks = {};
const provide = { getObjProperty };
const stubs = {};

const setEditItemsMock = jest.fn(() => true);

const store_modules = {
  cart: {
    namespaced: true,
    state: {
      cart: {
        totals: {
          membershipSavings: 1,
          potentialMembershipSavings: 0
        }
      }
    },
    mutations: {
      setEditAllItems: setEditItemsMock
    }
  },

  customer: {
    namespaced: true,
    getters: {
      hasMembershipPricing: jest.fn(() => false)
    }
  }
};

let wrapper;

/**** TESTS ****/
describe('SubscribeToSave', function () {
  it("does not display content if the user is not getting membershipPricing", function() {
    wrapper = createWrapper();
    expect(wrapper.contains('.cart-membership-program')).toBe(false);

    store_modules.customer.getters.hasMembershipPricing = jest.fn(() => true);
    wrapper = createWrapper();
    expect(wrapper.contains('.cart-membership-program')).toBe(true);
  });

  it('displays a subscribe and save button if user still has potential to save via a new subscription', function() {
    wrapper = createWrapper();
    expect(wrapper.contains('#cart-membership-program-subscribe-and-save')).toBe(false);

    store_modules.cart.state.cart.totals.potentialMembershipSavings = 1;
    wrapper = createWrapper();
    expect(wrapper.contains('#cart-membership-program-subscribe-and-save')).toBe(true);
  });

  test('expected function call when the subscribe button is clicked', function() {
    const btn = wrapper.find('#cart-membership-program-subscribe-and-save');
    btn.trigger('click');
    expect(setEditItemsMock.mock.calls.length).toBe(1);
  });
}); 